//#region Tagular component properties

// These stay around in the new implementation as they are used in components
import { ConversionTrackingInfo } from "@/constants/tagular/main";

export interface TagularIndexedProps {
  index?: number;
}

export enum TagularAction {
  STARTED = "Started",
  COMPLETED = "Completed",
  RECEIVED = "Received",
  APPROVED = "Approved",
  DECLINED = "Declined",
  CANCELLED = "Cancelled",
  ACTIVATED = "Activated",
  VIEWED = "Viewed",
  OPENED = "Opened",
  SUBMITTED = "Submitted",
  CONTINUE = "Continue",
  UPGRADED = "Upgraded",
}

export enum TagularCategory {
  APPLICATION = "Application",
  LEAD = "Lead",
  CART = "Cart",
  PHONE_ORDER = "PhoneOrder",
  SUBSCRIPTION = "Subscription",
  CLICK = "Click",
  APPOINTMENT = "Appointment",
  CALL = "Call",
  CHAT = "Chat",
  EMAIL = "Email",
  SMS = "SMS",
  FORM = "Form",
  ACCOUNT = "Account",
  ENROLLMENT = "Enrollment",
}

interface TagularEventingOptionalProps {
  conversionTrackingInfo?: ConversionTrackingInfo;
  action?: TagularAction;
  category?: TagularCategory;
}

export interface TagularEventingSimpleProps {
  html_id?: string;
  location?: string;
  position?: number;
}

export type TagularEventingRequiredProps = TagularEventingOptionalProps &
  TagularEventingSimpleProps;

//#endregion
